// @flow strict

export default (value: empty | '%future added value') => {
  // eslint-disable-next-line no-console
  console.error('Reached impossible case. Check your flow types', value)
  // eslint-disable-next-line no-console
  console.trace()
}
